// operation_klass strings required to view the realtime auction screen: loading the summary data
// AND subscribing to the realtime bidding channel. Missing either one means the user cannot
// meaningfully use the screen, so the "Visualizar" entry button is disabled and the screen body
// falls back to the no-permission empty state.
export const AUCTION_VIEW_PERMISSIONS = [
  'Client::Maintenance::EstablishmentChoice::AuctionEntries::RetrieveUpdatedSummary',
  'Client::Maintenance::EstablishmentChoice::AuctionEntries::BiddingChannel::Subscribed',
];
